import { useTranslation } from "react-i18next";
import { Copy, Fingerprint } from "lucide-react";
import { toast } from "sonner";

// الرقم التسلسلي للشركة: هوية ثابتة (8 أرقام) تُذكر في طلبات الدعم — غير قابلة للتعديل.
export const CompanySerial = ({ serial, className = "" }) => {
  const { t } = useTranslation();
  if (!serial) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(serial);
      toast.success(t("company.serialCopied"));
    } catch {
      toast.error(t("errors.generic"));
    }
  };

  return (
    <div className={`neu-in flex items-center justify-between gap-3 rounded-2xl px-4 py-3 ${className}`}>
      <div className="min-w-0">
        <p className="label-xs flex items-center gap-2">
          <Fingerprint className="h-4 w-4 text-primary" /> {t("company.serial")}
        </p>
        <p className="mt-1 text-lg font-bold tracking-widest num" data-testid="company-serial-value">
          {serial}
        </p>
      </div>
      <button
        type="button"
        onClick={copy}
        className="shrink-0 rounded-xl p-2 text-primary shadow-neu-sm transition-transform hover:scale-105"
        data-testid="company-serial-copy"
        aria-label={t("company.serialCopy")}
      >
        <Copy className="h-4 w-4" />
      </button>
    </div>
  );
};
